import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.formGroup', {
      layout: {
        table: {
          display: 'table-row',
        },
        block: {
          display: 'block',
        },
        inline: {
          display: 'inline-flex',
          mb: 24,
          mr: 48,
        },
      },
      labelText: {
        fontSize: '14px',
        lineHeight: '22px',
        layout: {
          block: {
            display: 'block',
            pb: 'x',
            pt: '5px',
          },
          inline: {
            display: 'inline-flex',
            pt: '5px',
            pr: '3x',
          },
          table: {
            display: 'table-cell',
            verticalAlign: 'top',
            maxWidth: 136,
            pt: '5px',
            pr: '3x',
          },
        },
        tooltip: {
          ml: 8,
          display: 'flex',
          alignSelf: 'center',
        },
      },
      requiredSymbol: {
        color: 'danger',
        ml: 4,
        fontWeight: 'normal',
      },
      error: {
        color: 'danger',
        mt: 4,
        fontSize: '12px',
        lineHeight: '18px',
      },
      helper: {
        color: 'mute',
        mt: 4,
        fontSize: '12px',
        lineHeight: '18px',
      },
    }),
  ]
}
